import {
    PostFormAvatar,
    PostFormGroupNameTypography,
    PostFormHeaderTitleSection,
} from "./PostForm.styles";
import React from "react";
import { UserAvatarFactory } from "../../UserAvatar/UserAvatarFactory";
import {
    CardHeaderPostHeader,
    PostCardHeaderTitleSection,
    TypographyHeaderTitle,
} from "../Post.styles";
import { getUserName } from "../../../Shared/UserHelpers";
import { UsersSolidIcon } from "../../Icon/UsersSolidIcon";
import { useUserProfile } from "../../../../Infrastructure/Persistence/UserProfileState";
import { AvatarOptions } from "../../UserAvatar/UserAvatar.types";
import userAvatarChecker from "../../../Shared/UserAvatarChecker";

export function PostFormHeader() {
    const { screenName, avatar, uuid, gender } = useUserProfile();
    const showProfilePicture = true;
    const avatarOptions: AvatarOptions = {
        uuid: uuid ?? null,
        avatar: showProfilePicture ? avatar : undefined,
        gender: gender,
        fallbackColor: !uuid ? "#596E38" : undefined,
        onError: () => userAvatarChecker(avatar, uuid),
        component: PostFormAvatar,
    };
    return (
        <CardHeaderPostHeader
            avatar={UserAvatarFactory(avatarOptions)}
            title={
                <PostCardHeaderTitleSection>
                    <TypographyHeaderTitle>
                        {getUserName(screenName ?? "Dein Anzeigename")}
                    </TypographyHeaderTitle>
                </PostCardHeaderTitleSection>
            }
            subheader={
                <PostFormHeaderTitleSection>
                    <UsersSolidIcon />
                    <PostFormGroupNameTypography>
                        Veröffentlicht in dieser Community
                    </PostFormGroupNameTypography>
                </PostFormHeaderTitleSection>
            }
            sx={{ marginBottom: "16px" }}
        />
    );
}
